<template>
  <div class="appBody prh-main bg-grey-light w-100">
    <little-header></little-header>
    <div class="lec-header">

    </div>
    <little-footer></little-footer>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Card} from 'vant';

  Vue.use(Card);
  import CardComponent from '@/components/cardComponent'
  import RowCardComponent from "@/components/rowCardComponent";
  import tabbarComponent from '@/components/tabbarComponent';
  import littleFooter from '@/page/lecturer/components/littleFooter';
  import LittleHeader from "@/components/littleHeader";

  export default {
    name: "lecturer",
    components: {
      tabbarComponent,
      CardComponent,
      littleFooter,
      LittleHeader,
      RowCardComponent
    },
    data() {
      return {
        tabArr: [],
        bigTab: 'bigTab',
        footTab: 'footTab',
        curTeacher: [],
        courseList: [],
        zhuanlanList: [],
        qunzuLian: [],
        zhiboList: [],
        tid: '',
        user: {}
      }
    },
    mounted() {
      this.tid = this.$route.params['uid'];
      this.getTeacherById();
    },
    methods: {
      getTeacherById() {
        this.$store.dispatch('getLectureById', {id: this.tid}).then((res) => {
          this.curTeacher = res['userInfoDTO'];
          this.user = res['user']
        })
      }
    }
  }
</script>

<style>
  .top-bner {
    height: 8.75rem;
    overflow: hidden;
  }

  .zj-course-item {
    background-color: white;
    padding: 0;
  }

  .zj-course-item .van-card__content {
    min-height: auto;
  }
  .prh-my-course .zj-course-item .van-card__thumb {
    width: 5rem !important;
    height: 5rem !important;
    margin-right: 1rem;
  }
</style>
